import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.getHeight
import com.github.chosamuel.kishibe.application.getWidth
import com.github.chosamuel.kishibe.application.mouseX
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.application.renderer.clear
import com.github.chosamuel.kishibe.color.cosineColor
import com.github.chosamuel.kishibe.graphics.Mesh
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.kishibe.math.map
import com.github.chosamuel.kishibe.noise.simplex
import com.github.chosamuel.kishibe.ui.XYPad
import kotlinx.browser.window
import org.khronos.webgl.WebGLRenderingContext as GL
import org.khronos.webgl.WebGLRenderingContext.Companion.BROWSER_DEFAULT_WEBGL
import org.khronos.webgl.WebGLRenderingContext.Companion.TRIANGLE_FAN
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sin

val xy = XYPad()

fun main(){
    console.log("""
        PHOSPHENE/SPECTRAL EYE 2021
        Made by Tsao
        with love 
        
        Twitter: @_samuelcho
        Instagram: @_samuelcho_
    """.trimIndent())
    xy.appendToDocument()
}


val app = Application {
    draw {
        val bg = cosineColor(
            frameCount*0.001 + 69.0
        )
        clear(bg[0],bg[1],bg[2])
        val r = Mesh(gl, this)
        val vertices = listOf(
            Vector2(0.0,0.0),
            Vector2(getWidth(),0.0),
            Vector2(0.0,getHeight()),
            Vector2(getWidth(),getHeight())
        )
        vertices.forEach {r.addVertex(it)}
        repeat(4){
            val t = simplex(
                vertices[it].x * 0.0005,
                vertices[it].y * 0.0005,
                frameCount* (0.005*m.y),
                0.0
            )
            val col = cosineColor(
                frameCount * 0.001 + t
            )
            r.addColor(Color(col[0]*m.x,col[1]*m.x,col[2]*m.x))
        }
        val indices = listOf( 0, 1, 2, 1, 3, 2 )
        indices.forEach { r.addIndex(it.toShort()) }
        r.draw(GL.TRIANGLES)
        drawSpectralEye()
    }
}